var _rect, _text, _text2, _rect2, _rect3, _rect4, _text3, _circle, _text4, _circle2, _text5, _circle3, _text6, _circle4, _text7, _circle5, _text8, _rect5, _text9, _circle6, _text10, _line, _line2, _rect6, _rect7, _rect8, _text11, _circle7, _text12, _circle8, _text13, _circle9, _text14, _circle10, _text15, _circle11, _text16, _rect9, _text17, _text18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg09LoopVsHarness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 480",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 480,
    fill: "#f8fafc"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 38,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 700
  }, "Loop vs Harness")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 62,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13
  }, "Different jobs. Production agents need both.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 400,
    height: 320,
    rx: 18,
    fill: "#ffffff",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 400,
    height: 64,
    rx: 18,
    fill: "#e5e7eb",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 138,
    width: 400,
    height: 16,
    fill: "#e5e7eb"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 130,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 700
  }, "Loop Engineering")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 195,
    r: 8,
    fill: "#64748b"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 200,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "What to do next")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 235,
    r: 8,
    fill: "#64748b"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 240,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "When to retry or stop")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 275,
    r: 8,
    fill: "#64748b"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 280,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "State across iterations")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 315,
    r: 8,
    fill: "#64748b"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 320,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "Completion criteria")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 355,
    r: 8,
    fill: "#64748b"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 360,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "Trace on graceful exit")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 375,
    width: 340,
    height: 22,
    rx: 8,
    fill: "#f1f5f9"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 391,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Focus: behavior over time")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 250,
    r: 28,
    fill: "#0f172a"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 256,
    textAnchor: "middle",
    fill: "#ffffff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "AND")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 250,
    x2: 452,
    y2: 250,
    stroke: "#0f172a",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 508,
    y1: 250,
    x2: 520,
    y2: 250,
    stroke: "#0f172a",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 90,
    width: 400,
    height: 320,
    rx: 18,
    fill: "#ffffff",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 90,
    width: 400,
    height: 64,
    rx: 18,
    fill: "#bfdbfe",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 138,
    width: 400,
    height: 16,
    fill: "#bfdbfe"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 130,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 700
  }, "Harness Engineering")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 195,
    r: 8,
    fill: "#3b82f6"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 200,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "Tools and permissions")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 235,
    r: 8,
    fill: "#3b82f6"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 240,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "Sandbox and quotas")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 275,
    r: 8,
    fill: "#3b82f6"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 280,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "Persistent memory")), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 315,
    r: 8,
    fill: "#3b82f6"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 320,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "Crash recovery")), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 355,
    r: 8,
    fill: "#3b82f6"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 360,
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14
  }, "Observability and logs")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 375,
    width: 340,
    height: 22,
    rx: 8,
    fill: "#dbeafe"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 391,
    textAnchor: "middle",
    fill: "#1e40af",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Focus: environment and safety")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 450,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Loop decides. Harness permits, protects, persists, and observes.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg09LoopVsHarness);
export default __webpack_public_path__ + "static/media/09-loop-vs-harness.153d5c19b7abc3dbeb3e67bfeca0c0bc.svg";
export { ForwardRef as ReactComponent };